import React, { useState } from 'react'
import { createStructuredSelector } from 'reselect'
import { branch, renderComponent } from 'recompose'

import { CardSection } from '@components/CardSection'
import { VehicleTabs } from '@components/VehicleTabs'
import ErrorMessage from '@components/ErrorMessage'
import Button from '@components/Button'
import VehicleFormModal from '@components/VehicleFormModal'
import LoginSignUpContainer from '@components/LoginSignUpContainer'

import { vehiclesSelector, selectedSeasonTicketSelector } from '@booking/selectors'
import { withTranslate } from '@i18n/utils'
import { userSelector } from 'auth/selectors'

const $VehicleSelection = ({
    userVehicles,
    onNext,
    selectedSeasonTicket,
    translate: t,
    flowSelectedVehicles,
    noLimit = false,
}) => {
    const [selectedVehicles, setSelectedVehicles] = useState(flowSelectedVehicles || [])

    const { isMultipleVehicle, numberOfVehicles: rateNumberOfVehicles } = selectedSeasonTicket?.rate || {}
    const numberOfVehicles = isMultipleVehicle ? rateNumberOfVehicles : 1

    return (
        <CardSection className="p-6">
            {!noLimit && (
                <p>
                    <T values={{ number: numberOfVehicles }}>purchase.flow.vehicles.description</T>
                </p>
            )}
            <p className="mt-4 mb-3 font-weight-bold">
                <T>purchase.flow.vehicles</T>
            </p>
            {selectedVehicles.length === 0 && (isMultipleVehicle || noLimit) && (
                <ErrorMessage messages={[t('purchase.flow.vehicles.add.vehicle.warning')]} type="text" />
            )}
            <div className="d-flex flex-column">
                <VehicleTabs
                    setSelectedVehicles={setSelectedVehicles}
                    vehicles={selectedVehicles}
                    userVehicles={userVehicles}
                    maxVehicles={noLimit ? userVehicles.length : numberOfVehicles}
                    isVehiclesListOpen
                    canAddPlate={false}
                />

                <VehicleFormModal />
                <div className="d-flex justify-content-end mt-6">
                    <Button
                        btnStyle="primary"
                        onClick={() => onNext(selectedVehicles)}
                        disabled={selectedVehicles.length < 1}>
                        <T>subscription.purchase.label.next</T>
                    </Button>
                </div>
            </div>
        </CardSection>
    )
}

const VehicleSelection = compose(
    connect(
        createStructuredSelector({
            userVehicles: vehiclesSelector,
            user: userSelector,
            selectedSeasonTicket: selectedSeasonTicketSelector,
        })
    ),
    withTranslate,
    branch(({ user }) => !user, renderComponent(LoginSignUpContainer), renderComponent($VehicleSelection))
)(VehicleSelection)

export default VehicleSelection
